import { render, staticRenderFns } from "./appbar2.vue?vue&type=template&id=57536148&scoped=true&"
import script from "./appbar2.vue?vue&type=script&lang=js&"
export * from "./appbar2.vue?vue&type=script&lang=js&"
import style0 from "./appbar2.vue?vue&type=style&index=0&id=57536148&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57536148",
  null
  
)

export default component.exports